import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { SubrentalReportFilterModel } from 'src/app/models/subrental/subrental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { SubrentalReportService } from 'src/app/services/subrental/subrental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-item-preinvoiced-value',
  templateUrl: './item-preinvoiced-value.component.html',
  styleUrls: ['./item-preinvoiced-value.component.scss'],
  standalone: false
})
export class ItemPreinvoicedValueComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  branchId: number = 0;
  enterpriseId: number = 0;
  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredEnterprise: any[] = [];
  filteredSubgroups: any[] = [];
  formSubrentalReportFilter: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listArticle: any[] = [];
  listBranch: any[] = [];
  listEnterprise: any[] = [];
  listGroup: any[] = [];
  listSubgroup: any[] = [];
  nameWindow: string = 'Informe Valor Prefacturado por Equipo';
  projectName = ProjectName.projectName;
  url: string = "";

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private groupService: GroupService,
    private headerService: HeaderService,
    private rentalPeriodService: RentalPeriodService,
    private router: Router,
    private subgroupService: SubgroupService,
    private subrentalReportService: SubrentalReportService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getPermission();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();

    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    } else {
      localStorage.clear();
    }
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formSubrentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeBranch(branchId: number) {
    this.filterEnterpriseByBranchId(branchId);
    this.branchId = branchId;
    this.changeFilter();
  }

  changeEnterprise(enterpriseId: number) {
    this.enterpriseId = enterpriseId;
    this.changeFilter();
  }

  async changeFilter() {
    this.changeFilters = false;
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
    } else {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
      this.formSubrentalReportFilter.controls["groupId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubgroup.find(x => x.value === subgroupId)!.groupId;
      this.formSubrentalReportFilter.controls["groupId"].patchValue(groupId);
      this.filterSubgroupByGroupId(groupId);
    } else {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilter();
  }

  clear() {
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.changeFilter();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formSubrentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formSubrentalReportFilter.get("dateFinal")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      const modelSubrentalReportFilter = this.formSubrentalReportFilter.value as SubrentalReportFilterModel;
      modelSubrentalReportFilter.year = parseInt(year);
      modelSubrentalReportFilter.period = parseInt(period);
      modelSubrentalReportFilter.yearFinal = parseInt(yearFinal);
      modelSubrentalReportFilter.periodFinal = parseInt(periodFinal);

      try {
        const response = await firstValueFrom(this.subrentalReportService.exportSubrentalReportItemPreinvoicedValue(modelSubrentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe Valor Prefacturado por Equipo.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterEnterpriseByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredEnterprise = this.listEnterprise.filter(x => x.branchId === branchId);
      this.formSubrentalReportFilter.controls["enterpriseId"].patchValue(0);
    } else {
      this.filteredEnterprise = this.listEnterprise;
    }
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubgroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formSubrentalReportFilter.get("subgroupId")?.value;
      const subgroupExists = this.listSubgroup.some(x => x.groupId === groupId && x.value === subgroupId);

      if (subgroupId && !subgroupExists) {
        this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubgroup;
    }
  }

  async getAllLists() {
    try {
      const [articles, branches, enterprises, groups, subgroups] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      this.filteredSubgroups = this.listSubgroup;
      this.listEnterprise = enterprises;
      this.filteredEnterprise = this.listEnterprise;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formSubrentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.branchId = branch.branchId;
      this.getLastRentalPeriod(branch.branchId);
      this.filterEnterpriseByBranchId(branch.branchId);
      this.filteredSubgroups = this.listSubgroup;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formSubrentalReportFilter.controls["dateInitial"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
      this.formSubrentalReportFilter.controls["dateFinal"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  getPermission() {
    const url = this.router.url as string
    this.url = url.substring(1);
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
        this.router.navigate(['/main']);
      }
    } else {
      localStorage.clear();
    }

    this.getAllLists();
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formSubrentalReportFilter.controls).forEach(key => {
      const control = this.formSubrentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formSubrentalReportFilter.valid) {
      const dateInitial = this.formSubrentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formSubrentalReportFilter.get("dateFinal")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      const modelSubrentalReportFilter = this.formSubrentalReportFilter.value as SubrentalReportFilterModel;
      modelSubrentalReportFilter.year = parseInt(year);
      modelSubrentalReportFilter.period = parseInt(period);
      modelSubrentalReportFilter.yearFinal = parseInt(yearFinal);
      modelSubrentalReportFilter.periodFinal = parseInt(periodFinal);

      try {
        this.dataReport = await firstValueFrom(this.subrentalReportService.subrentalReportItemPreinvoicedValue(modelSubrentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      dateInitial: {
        required: 'El campo Período Inicial es obligatorio.'
      },
      dateFinal: {
        required: 'El campo Período Final es obligatorio.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      enterpriseId: {
        notNumber: 'Debe seleccionar una Empresa válida.'
      },
      groupId: {
        notNumber: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        notNumber: 'Debe seleccionar un Subgrupo válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formSubrentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formSubrentalReportFilter = this.formBuilder.group({
      dateInitial: ['', [Validators.required]],
      dateFinal: ['', [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      enterpriseId: [0, [CustomValidators.numberOnlyValidator()]],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }

}
